import { ExclamationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import {
  ChevronRightIcon,
  DocumentDuplicateIcon,
  MagnifyingGlassIcon,
  PhoneIcon,
} from "@heroicons/react/24/solid";
import { ActionIcon, Image, Text, TextInput, Tooltip } from "@mantine/core";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
// import { NavLink } from "react-router-dom";
import * as searchServices from "../../api/search";
import images from "../../assets";
// import config from "../../config";

function CopyField({
  children = "",
  className = "bg-gradient-to-b from-[#D3DAE3] to-[#9FA6B0]",
}) {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(children);
      setCopied(true);

      // Sau một khoảng thời gian, đặt lại trạng thái copied để cho phép sao chép lại
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    } catch (error) {
      console.error("Lỗi khi sao chép: ", error);
    }
  };
  return (
    <div
      className={`mx-2 py-1 px-3 w-36 max-h-7 rounded-full flex flex-row justify-between items-center ${className}`}
    >
      <Text className="text-sm text-white" fw={600}>
        {children}
      </Text>
      <Tooltip
        className="text-xs"
        label={copied ? "Đã sao chép" : "Sao chép"}
        position="top-end"
        withArrow
      >
        <ActionIcon variant="transparent" onClick={handleCopyClick}>
          <DocumentDuplicateIcon className="w-4 h-4" color="#fff" />
        </ActionIcon>
      </Tooltip>
    </div>
  );
}

function Home() {
  const textStyle =
    "text-sm font-normal mb-4 mt-0 sm:mt-2 text-center sm:text-left";
  const recapchaSiteKey = "6LcYL-YnAAAAAG8N-VpWz74E3xO-p5UmkcqSFUbt";
  const [isHidden, setHidden] = useState(false);
  const [buttonStyle, setButtonStyle] = useState("bg-blue-400");

  const [searchValue, setSearchValue] = useState("");
  const [searchFailed, setSearchFailed] = useState({
    Icon: null,
    message: "",
  });

  const [responseData, setResponseData] = useState([]);
  const [createdDate, setCreatedDate] = useState("");

  const [isRecaptchaVerified, setRecaptchaVerified] = useState(false);
  const recaptchaRef = useRef();

  const [isLoading, setLoading] = useState(false);

  const searchProcessing = () => {
    if (searchValue.trim().length === 0) {
      setSearchFailed({ Icon: null, message: "Vui lòng nhập số CID" });
    } else {
      setLoading(true);
      const fetchData = async () => {
        try {
          const params = {
            cid: searchValue.trim(),
          };

          const response = await searchServices.searchCID(params);
          setResponseData(response.data);
        } catch (error) {
          console.error("API Error:", error);
          setLoading(false);
          setSearchFailed({
            Icon: null,
            message: "Lỗi kết nối server",
          });
        }
      };
      fetchData();
    }
  };

  const recaptchaVerify = (value) => {
    setRecaptchaVerified(true);
    if (recaptchaVerify) {
      setButtonStyle("bg-[#0066ff] hover:bg-[#002fff] hover:scale-105");
    }
  };

  useEffect(() => {
    if (responseData.data) {
      const date = new Date(responseData.data.createdDate);
      const formattedDate = format(date, "dd/MM/yyyy");
      setCreatedDate(formattedDate);
      setLoading(false);
      setHidden(true);
    } else {
      setSearchFailed({
        Icon: <ExclamationCircleIcon className="w-5 h-5" color="#F40B0B" />,
        message: "Số CID không hợp lệ",
      });
      setLoading(false);
      setButtonStyle("bg-blue-400");
      setRecaptchaVerified(false);
      recaptchaRef.current.reset();

    }
  }, [responseData]);

  useEffect(() => {
    if (searchValue.trim().length === 0) {
      setSearchFailed({ Icon: null, message: "" });
    }
  }, [searchValue]);

  useEffect(() => {}, [searchValue]);
  const closeCard = () => {
    setHidden(false);
    setResponseData([]);
    setSearchFailed({ Icon: null, message: "" });
    setSearchValue("");
    setRecaptchaVerified(false);
    setButtonStyle("bg-blue-400");
  };

  return (
    <div className="w-full h-full min-w-[22.75rem] flex justify-center items-center">
      <div className="w-[90%] md:w-[90%] lg:w-[65%] h-[90%] sm:h-[50%] mb-[10vh] flex flex-col items-center">
        <div className="flex flex-col items-center w-full">
          <div className="flex flex-col text-center mt-[10vh] sm:mt-0 sm:justify-center">
            <Text className="text-[1.75rem] tracking-wider" fw={600}>
              TRA CỨU KEYS S1
            </Text>
          </div>
          <div className="text-center" hidden={isHidden}>
            <Text className="text-[0.875rem] tracking-wider py-2" fw={400}>
              Nhập số CID bên dưới để tra cứu Regcode
            </Text>
            {/* <NavLink
              className="text-[0.875rem] tracking-wide font-medium text-blue-500 w-fit"
              to={config.routes.support}
            >
              Cách tìm số CID của bạn
              <ChevronRightIcon className="h-5 w-5 text-blue-500 inline pl-1 mb-[1px]" />
            </NavLink> */}
            <a
              className="text-[0.875rem] tracking-wide font-medium text-blue-500 w-fit hover:underline"
              href="https://www.youtube.com/watch?v=9DOFG7AWxZM&ab_channel=VIETMAPH%E1%BB%97Tr%E1%BB%A3K%E1%BB%B9Thu%E1%BA%ADt"
              target="_blank"
            >
              Cách tìm số CID của bạn
              <ChevronRightIcon className="h-5 w-5 text-blue-500 inline pl-1 mb-[1px]" />
            </a>
          </div>
          <div
            className="w-full lg:w-[55%] max-w-md my-7 sm:my-11"
            hidden={isHidden}
          >
            <TextInput
              placeholder="Nhập số CID"
              className="sm:focus-within:scale-105 md:min-w-[21.25rem]"
              radius="md"
              icon={<MagnifyingGlassIcon className="w-4 h-4" />}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              rightSection={searchFailed.Icon}
              error={searchFailed.message}
            />
          </div>
          <div className="w-full pb-4 flex justify-center">
            {isLoading && (
              <img
                src={images.loading}
                alt="Logo"
                title="Logo"
                className="animate-spin"
              />
            )}
          </div>
          <div className="pb-3" hidden={isHidden}>
            <ReCAPTCHA
              sitekey={recapchaSiteKey}
              onChange={recaptchaVerify}
              ref={recaptchaRef}
            />
          </div>
          <div className="w-full sm:w-[85px] max-w-md" hidden={isHidden}>
            <button
              className={` px-4 py-[0.5rem] w-full rounded-md text-sm text-white font-medium ${buttonStyle}`}
              onClick={searchProcessing}
              disabled={!isRecaptchaVerified}
            >
              Tra cứu
            </button>
          </div>

          <div
            className="w-full sm:w-[80%] max-w-[42rem] min-w-[22.75rem] sm:min-w-[39.75rem] bg-[#EFF1F1] p-4 rounded-lg my-10"
            hidden={!isHidden}
          >
            <div className="w-full flex justify-end ">
              <ActionIcon>
                <XMarkIcon
                  className="w-5 h-5"
                  color="#191C1D"
                  onClick={closeCard}
                />
              </ActionIcon>
            </div>
            <div className="flex flex-col sm:flex-row justify-center items-center">
              <div>
                <Image
                  maw={104}
                  mx="auto"
                  src={images.device}
                  alt="Random image"
                />
              </div>
              <div className="ml-0 sm:ml-8">
                <Text
                  className="text-base pb-2 sm:pb-3 text-center sm:text-left"
                  color="#0066ff"
                  fw={500}
                >
                  VIETMAP S1
                </Text>
                <div className="flex flex-col sm:flex-row w-full">
                  <div className="">
                    <Text className={textStyle}>
                      Ngày đăng ký:&ensp;{responseData.data ? createdDate : " "}
                    </Text>
                    <Text className={textStyle}>
                      CID: &ensp;
                      {responseData.data ? responseData.data.cid : " "}
                    </Text>
                  </div>
                  <div className="ml-8 flex flex-row">
                    <div>
                      <Text className={textStyle}>Mã đăng ký cũ:&ensp;</Text>
                      <Text className={textStyle}>Mã đăng ký mới:</Text>
                    </div>
                    <div className="flex flex-col mt-[-5px] sm:mt-1">
                      <CopyField>
                        {responseData.data
                          ? responseData.data.oldCode != null
                            ? responseData.data.oldCode
                            : ""
                          : ""}
                      </CopyField>
                      <CopyField className="bg-gradient-to-b from-[#87B7FF] to-[#06F] mt-2">
                        {responseData.data
                          ? responseData.data.newCode != null
                            ? responseData.data.newCode
                            : ""
                          : ""}
                      </CopyField>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-14 sm:relative mt-0 sm:mt-[20vh] text-center">
          <div className="flex flex-col md:flex-row">
            <Text className="text-sm font-normal tracking-wider">
              Bất cứ khi nào cần sự hỗ trợ từ Vietmap,&ensp;
            </Text>
            <Text className="text-sm font-normal tracking-wider">
              Quý khách vui lòng liên hệ hotline CSKH miễn phí
            </Text>
          </div>
          <Text className="text-base font-medium text-blue-500 tracking-wide py-3 flex justify-center items-center">
            <PhoneIcon className="w-5 h-5 text-blue-500 inline mr-2 mt-[1px]" />
            0896164567
          </Text>
          <Text className="text-sm font-normal tracking-wider">
            Vietmap hân hạnh được phục vụ Quý khách!
          </Text>
        </div>
      </div>
    </div>
  );
}

export default Home;
